import React from 'react'
import { Box, Container, Grid, Fade, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useReduxSelector } from '../../hooks'
import { img as imgs, img } from '../../imgs'
import { TimerStart } from '../timer'

export const StartPage: React.FC<{ timeStart: number; text: string; minHeight?: string }> = ({
  timeStart = 0,
  text,
  minHeight = '100vh',
}): JSX.Element => {
  const classes = useStyles()

  const { data: constants } = useReduxSelector((state) => state.constants)

  const { IS_PROJECT_START_ACTION } = constants || {}

  return (
    <Fade in timeout={{ enter: 600 }}>
      <Box className={classes.page}>
        <Grid container justifyContent="center" alignItems="center" style={{ minHeight: `${minHeight}` }} spacing={0}>
          <Grid item>
            <Container className={classes.container}>
              <Grid container justifyContent="center" alignItems="center">
                <Grid item>
                  <Box display="flex" justifyContent="center">
                    <img src={img.logoStart} alt="" className={classes.logoStart} />
                  </Box>
                  <Box className={classes.text}>{text}</Box>
                </Grid>
              </Grid>
            </Container>
            {timeStart > 0 && (
              <>
                <Box className={classes.counter} sx={{ display: { xs: 'none', md: 'block' } }}>
                  <Grid container wrap="nowrap" justifyContent="center" alignItems="center">
                    <Grid item xs={3}>
                      <img src={img.leftCount} alt="" className={classes.leftCount} />
                    </Grid>
                    <Grid item xs="auto">
                      <Container className={classes.contCount}>
                        {timeStart && <TimerStart classes={classes} timeEnd={timeStart} />}
                      </Container>
                    </Grid>
                    <Grid item xs={3}>
                      <img src={img.rightCount} alt="" className={classes.rightCount} />
                    </Grid>
                  </Grid>
                </Box>
                <Box className={classes.counter} sx={{ display: { xs: 'block', md: 'none' } }}>
                  <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs="auto">
                      <Container className={classes.contCount}>
                        {timeStart && <TimerStart classes={classes} timeEnd={timeStart} />}
                      </Container>
                    </Grid>
                    <Grid item xs={12}>
                      <img src={img.countSm} alt="" className={classes.countSm} />
                    </Grid>
                  </Grid>
                </Box>
              </>
            )}
          </Grid>
        </Grid>
        {timeStart === 0 && <img src={imgs.newsBottom} alt="" className={classes.bannerBottom} />}
      </Box>
    </Fade>
  )
}

const useStyles = makeStyles(({ breakpoints: { down }, palette }: Theme) => ({
  page: {
    width: '100%',
    height: '100%',
    minHeight: 950,
    overflow: 'hidden',
    color: palette.primary.contrastText,
    userSelect: 'none',
    [down('md')]: {
      minHeight: '92.7vw',
    },
  },
  container: {
    maxWidth: '1000px!important',
  },
  logoStart: {
    [down('md')]: {
      width: '65vw',
    },
    [down('sm')]: {
      width: '70vw',
    },
  },
  text: {
    textTransform: 'uppercase',
    fontSize: 28,
    fontWeight: 700,
    textAlign: 'center',
    marginTop: 50,
    [down('md')]: {
      fontSize: '3.5vw',
      marginTop: '20vw',
    },
    [down('sm')]: {
      fontSize: '3.7vw',
    },
  },
  counter: {
    marginTop: 30,
    [down('md')]: {
      marginTop: '3.1vw',
    },
  },
  leftCount: {
    minWidth: 490,
    width: '100%',
    marginTop: -40,
  },
  rightCount: {
    minWidth: 490,
    width: '100%',
    marginTop: -40,
  },
  countSm: {
    width: '100%',
    [down('md')]: {
      marginTop: '5vw',
    },
  },
  contCount: {
    padding: '0px!important',
    backgroundColor: palette.primary.dark,
  },
  num: {
    float: 'left',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,
    backgroundColor: '#292929',
    color: '#BABABA',
    fontWeight: 700,
    fontSize: 75,
    marginLeft: 7,
    marginRight: 7,
    width: 90,
    height: 110,
    marginBottom: 15,
    [down('md')]: {
      width: '8.7vw',
      height: '11vw',
      marginLeft: '0.73vw',
      marginRight: '0.73vw',
      borderRadius: '1.04vw',
      fontSize: '7.8vw',
      marginBottom: '1.6vw',
    },
  },
  ml: {
    marginLeft: '0px!important',
  },
  mr: {
    marginRight: '0px!important',
  },
  boxDots: {
    width: 40,
    height: 110,
    float: 'left',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [down('md')]: {
      width: '3vw',
      height: '11vw',
    },
  },
  dots: {
    width: 17,
    height: 17,
    borderRadius: '50%',
    backgroundColor: '#BABABA',
    margin: '15px 0',
    [down('md')]: {
      width: '1.6vw',
      height: '1.6vw',
      margin: '1.4vw 0',
    },
  },
  titleСount: {
    width: 190,
    fontSize: 16,
    fontWeight: 700,
    textTransform: 'uppercase',
    textAlign: 'center',
    margin: 5,
    [down('md')]: {
      width: '19.8vw',
      fontSize: '1.6vw',
      margin: '0.5vw',
    },
    [down('sm')]: {
      fontSize: '1.8vw',
    },
  },
  bannerBottom: {
    width: '100%',
    minWidth: 1100,
  },
}))
